/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import {
  Box,
  Grid,
  Switch,
  TextField,
  InputAdornment,
  FormControlLabel,
  ListItem,
  ListItemIcon,
  ListItemText,
  Chip,
  Link,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Paper,
  Tooltip,
} from '@mui/material';

import {
  AttachMoney,
  MoneyOff,
} from '@mui/icons-material';
import NoteAlt from '@mui/icons-material/NoteAlt';
import Visibility from '@mui/icons-material/Visibility';
import { blueGrey } from '../../../utils/brandColors';
import NoteTypeSelect from '../../EnumSelects/NoteTypeSelect';
import ImportanceSelect from '../../EnumSelects/ImportanceSelect';
import BillableStatusSelectComponent from '../../EnumSelects/BillableStatusSelect';
import AddEditBillableModal from '../../../pages/billing/components/AddEditBillableModal';
import {
  getBillableForTask,
  getNoteForTask,
} from '../../../redux/app/actions';
import { getColorForBillableStatus } from '../../../pages/billing/components/BillablesTable';
import AddEditModal from '../../../pages/horse/Horse/components/NotesCard/components/AddEditModal';
import BillableItem from '../../BillableItem';
import NoteItemComponent from '../../NoteItem/NoteItem';

function isNumber(n) { return !Number.isNaN(parseFloat(n)) && !Number.isNaN(n - 0) }

export const EditTaskEventDataComponent = ({
  onChange,
  taskEventData,
  completeDate,
  selectedEvent,
  barnHorse,
  showDivider,
}) => {
  const dispatch = useDispatch();

  const [editEventData, setEditEventData] = React.useState({});
  const eventData = useSelector((state) => state.eventData.eventData);
  const selectedBarn = useSelector((state) => state.barn.selectedBarn);
  // Associated billable for the horse on this task
  const horseBillable = useSelector((state) => state.app.billableForTask);
  const horseNote = useSelector((state) => state.app.noteForTask);

  const [changeBillable, setChangeBillable] = React.useState(false);
  const [changeNote, setChangeNote] = React.useState(false);
  const [openAddEditHorseBillableModal, setOpenAddEditHorseBillableModal] = React.useState(false);
  const [openAddEditHorseNoteModal, setOpenAddEditHorseNoteModal] = React.useState(false);

  React.useState(() => {
    setEditEventData(taskEventData);
    setOpenAddEditHorseBillableModal(false);
    setOpenAddEditHorseNoteModal(false);
  }, [taskEventData]);

  const getEDNameFromId = (id) => (eventData.find((ed) => ed.id === id) || { name: 'Unknown' }).name
  const billableValue = (horseBillable && horseBillable.price)
    || (editEventData[getEDNameFromId(selectedBarn.barnMetadata.horseBillablePriceEventDataId)]
      && editEventData[getEDNameFromId(selectedBarn.barnMetadata.horseBillablePriceEventDataId)].value);
  const billableStatus = (horseBillable && horseBillable.status) || (editEventData['Billable Status']
    && editEventData['Billable Status'].value) || 'Open';
  const billableReceivable = (horseBillable && horseBillable.receivabe) || (editEventData['Billable Receivable']
    && editEventData['Billable Receivable'].value) || 'yes';

  const noteValue = (horseNote && horseNote.note) || (editEventData[getEDNameFromId(selectedBarn.barnMetadata.horseNoteEventDataId)]
    && editEventData[getEDNameFromId(selectedBarn.barnMetadata.horseNoteEventDataId)].value);
  const noteTypeValue = (horseNote && horseNote.type) || (editEventData[getEDNameFromId(selectedBarn.barnMetadata.horseNoteTypeEventDataId)]
    && editEventData[getEDNameFromId(selectedBarn.barnMetadata.horseNoteTypeEventDataId)].value);
  const noteImportanceValue = (horseNote && horseNote.importance)
    || (editEventData[getEDNameFromId(selectedBarn.barnMetadata.horseNoteImportanceEventDataId)]
      && editEventData[getEDNameFromId(selectedBarn.barnMetadata.horseNoteImportanceEventDataId)].value);
  const noteClientViewableValue = (horseNote && horseNote.clientViewable)
    || (editEventData[getEDNameFromId(selectedBarn.barnMetadata.horseNoteClientViewableEventDataId)]
      && editEventData[getEDNameFromId(selectedBarn.barnMetadata.horseNoteClientViewableEventDataId)].value);

  const handleDataChange = (edId, type, value) => {
    const newEventData = {
      ...editEventData,
      [isNumber(edId)
        ? getEDNameFromId(edId)
        : edId]: {
        type,
        value,
      },
    }
    if (edId === 'Billable Receivable') {
      newEventData['Billable Status'] = {
        type: 'Text',
        value: value === 'no'
          ? 'Expense'
          : 'Open',
      }
    }
    setEditEventData(newEventData);
    onChange(newEventData);
  }

  /*
    If there is a billable task/note or if the task is in complete state,
    we always use the addEdit modals for billable and note
    Else we will use the eventdata on the task which will create the billable once the
    task is put in complete status
  */

  return (
    <Box>
      <ListItem divider={showDivider} dense>
        <ListItemIcon><AttachMoney /></ListItemIcon>
        {
          (onChange || billableValue)
            ? (
              <ListItemText>
                {
                  changeBillable
                    ? (
                      <Grid container spacing={1} alignItems="center">
                        <Grid item xs={12}>
                          <FormControlLabel
                            control={(
                              <Switch
                                size="small"
                                checked={!!(billableValue || billableValue === '')}
                                onChange={(e) => {
                                  handleDataChange(selectedBarn.barnMetadata.horseBillablePriceEventDataId, 'CurrencyUSD', e.target.checked
                                    ? '0.00'
                                    : null)
                                }}
                                inputProps={{ 'aria-label': 'controlled' }}
                              />
                            )}
                            label="Task Billing Transaction"
                          />

                        </Grid>
                        {
                          (billableValue || billableValue === '') && (
                            <Grid item sx={{ width: 150 }}>
                              <TextField
                                size="small"
                                id="billable-price"
                                label="Amount"
                                value={billableValue}
                                onChange={(e) => {
                                  if (/^[0-9]\d*(\.\d+)?$/.test(e.target.value) || e.target.value === '-' || e.target.value === '') {
                                    handleDataChange(selectedBarn.barnMetadata.horseBillablePriceEventDataId, 'CurrencyUSD', e.target.value)
                                  }
                                }}
                                InputProps={{
                                  startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                  inputMode: 'numeric',
                                  type: 'number',
                                }}
                              />
                            </Grid>
                          )
                        }
                        {
                          (billableValue || billableValue === '') && (
                            <Grid item>
                              <FormControl fullWidth margin="none">
                                <InputLabel id="note-type-select-label">Type</InputLabel>
                                <Select
                                  labelId="horse-access-type-select-label"
                                  id="horse-access-type-select"
                                  value={billableReceivable || 'yes'}
                                  label="Type"
                                  size="small"
                                  onChange={(e) => {
                                    handleDataChange('Billable Receivable', 'YesNo', e.target.value)
                                  }}
                                >
                                  <MenuItem value="yes">
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <AttachMoney color="success" sx={{ mr: 1 }} />
                                      <Box>Billable</Box>
                                    </Box>
                                  </MenuItem>
                                  <MenuItem value="no">
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <MoneyOff sx={{ mr: 1 }} />
                                      <Box>Expense</Box>
                                    </Box>
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>
                          )
                        }
                        {
                          (billableValue || billableValue === '') && (
                            <Grid item sx={{ width: 150 }}>
                              {
                                (billableReceivable && billableReceivable !== 'no')
                                  ? (
                                    <BillableStatusSelectComponent
                                      value={billableStatus || 'Open'}
                                      size="small"
                                      includeExpenseOption={false}
                                      onChange={(e) => {
                                        handleDataChange('Billable Status', 'Text', e.target.value)
                                      }}
                                    />
                                  )
                                  : (
                                    <Box />
                                  )
                              }
                            </Grid>
                          )
                        }
                      </Grid>
                    )
                    : (
                      <Box>
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          {
                            billableValue && (
                              horseBillable
                                ? (
                                  <BillableItem
                                    handleBillablePress={() => {
                                      if (completeDate || (horseBillable && horseBillable.id)) {
                                        setOpenAddEditHorseBillableModal(true);
                                      } else {
                                        setChangeBillable(true)
                                      }
                                    }}
                                    billable={horseBillable}
                                    containerProps={{ sx: { cursor: 'pointer' } }}
                                    hideTitleDate
                                  />
                                )
                                : (
                                  <Chip
                                    size="small"
                                    sx={{ mr: 1 }}
                                    color={getColorForBillableStatus({ status: billableStatus || 'Open' })}
                                    icon={billableReceivable
                                      ? <AttachMoney />
                                      : <MoneyOff />}
                                    variant="outlined"
                                    label={billableValue}
                                  />
                                )
                            )
                          }
                          {
                            (onChange && !horseBillable)
                            && (
                              <Link
                                component="button"
                                variant="body2"
                                color="secondary"
                                underline="hover"
                                onClick={() => {
                                  if (completeDate || (horseBillable && horseBillable.id)) {
                                    setOpenAddEditHorseBillableModal(true);
                                  } else {
                                    setChangeBillable(true)
                                  }
                                }}
                              >
                                {(horseBillable || (editEventData[getEDNameFromId(selectedBarn.barnMetadata.horseBillablePriceEventDataId)])
                                  ? 'Modify'
                                  : 'Add')} Billing Transaction
                              </Link>
                            )
                          }
                        </Box>
                        {
                          (!completeDate && editEventData[getEDNameFromId(selectedBarn.barnMetadata.horseBillablePriceEventDataId)]
                            && !selectedBarn.barnMetadata.createBillableAtTaskCreation && !horseBillable)
                            ? (<Tooltip title="Based on your Questri Organization Horse Billing settings, Transactions are not generated until a task is completed. You can change this behavior from the Horse Billing page."><Typography variant="caption" sx={{ fontWeight: 300 }}>Transactions will not be created until this task is completed.</Typography></Tooltip>)
                            : <Box />
                        }
                      </Box>

                    )
                }
              </ListItemText>
            )
            : (
              <ListItemText primaryTypographyProps={{ fontWeight: 300 }}>No Billing Transaction</ListItemText>
            )
        }

      </ListItem>
      <ListItem dense>
        <ListItemIcon><NoteAlt /></ListItemIcon>
        {
          (onChange || noteValue)
            ? (
              <ListItemText>
                {
                  changeNote
                    ? (
                      <Grid container spacing={1}>
                        <Grid item xs={12}>
                          <FormControlLabel
                            control={(
                              <Switch
                                size="small"
                                checked={!!noteTypeValue}
                                onChange={(e) => {
                                  const newEventData = {
                                    ...editEventData,
                                    [getEDNameFromId(selectedBarn.barnMetadata.horseNoteTypeEventDataId)]: {
                                      type: 'Text',
                                      value: e.target.checked
                                        ? 'Note'
                                        : null,
                                    },
                                    [getEDNameFromId(selectedBarn.barnMetadata.horseNoteImportanceEventDataId)]: {
                                      type: 'Text',
                                      value: e.target.checked
                                        ? 'Inform'
                                        : null,
                                    },
                                    [getEDNameFromId(selectedBarn.barnMetadata.horseNoteEventDataId)]: {
                                      type: 'Text',
                                      value: e.target.checked
                                        ? ''
                                        : null,
                                    },
                                  }
                                  setEditEventData(newEventData);
                                  onChange(newEventData);
                                }}
                                inputProps={{ 'aria-label': 'controlled' }}
                              />
                            )}
                            label="Task Horse Note"
                          />
                        </Grid>
                        {
                          noteTypeValue && (
                            <Grid item>
                              <FormControlLabel
                                sx={{
                                  borderLeft: `1px solid ${blueGrey[50]}`,
                                  m: 0,
                                  pl: 1,
                                }}
                                labelPlacement="start"
                                label={(
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                    }}
                                  >Client Viewable <Visibility color="primary" sx={{ ml: 1 }} />
                                  </Box>
                                )}
                                control={(
                                  <Switch
                                    size="small"
                                    checked={noteClientViewableValue && noteClientViewableValue === 'Yes'}
                                    onChange={(e) => {
                                      handleDataChange(selectedBarn.barnMetadata.horseNoteClientViewableEventDataId, 'YesNo', e.target.checked
                                        ? 'Yes'
                                        : 'No')
                                    }}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                  />
                                )}
                              />
                            </Grid>
                          )
                        }
                        {
                          noteTypeValue && (
                            <Grid item>
                              <Grid container spacing={2}>
                                <Grid item>
                                  <NoteTypeSelect
                                    value={noteTypeValue}
                                    onChange={(e) => {
                                      handleDataChange(selectedBarn.barnMetadata.horseNoteTypeEventDataId, 'Text', e.target.value)
                                    }}
                                  />
                                </Grid>
                                <Grid item>
                                  <ImportanceSelect
                                    value={noteImportanceValue}
                                    onChange={(e) => {
                                      handleDataChange(selectedBarn.barnMetadata.horseNoteImportanceEventDataId, 'Text', e.target.value)
                                    }}
                                  />
                                </Grid>
                                <Grid item>
                                  <TextField
                                    sx={{ minWidth: 250 }}
                                    id="horse-note"
                                    size="small"
                                    multiline
                                    maxRows="3"
                                    label="Note"
                                    value={noteValue}
                                    onChange={(e) => {
                                      handleDataChange(selectedBarn.barnMetadata.horseNoteEventDataId, 'Text', e.target.value)
                                    }}
                                    InputProps={{ startAdornment: <InputAdornment position="start"><NoteAlt /></InputAdornment> }}
                                  />
                                </Grid>
                              </Grid>
                            </Grid>
                          )
                        }
                      </Grid>
                    )
                    : (
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        {
                          (noteValue)
                          && (horseNote
                            ? (
                              <Paper
                                sx={{
                                  flex: 1,
                                  pl: 1,
                                  cursor: 'pointer',
                                }}
                                onClick={(e) => {
                                  if (completeDate || (horseBillable && horseBillable.id)) {
                                    setOpenAddEditHorseNoteModal(true);
                                  } else {
                                    setChangeNote(true)
                                  }
                                  e.stopPropagation()
                                }}
                              >
                                <NoteItemComponent
                                  note={horseNote}
                                  divider={false}
                                  hideActions
                                  horseId={barnHorse.horse.id}
                                  condensed
                                />
                              </Paper>
                            )
                            : (
                              <Box sx={{ mr: 1 }}>
                                ({noteTypeValue}){' '}
                                {noteValue}
                              </Box>
                            )
                          )
                        }
                        {
                          onChange
                          && !horseNote && (
                            <Link
                              component="button"
                              variant="body2"
                              color="secondary"
                              underline="hover"
                              onClick={() => {
                                if (completeDate || (horseBillable && horseBillable.id)) {
                                  setOpenAddEditHorseNoteModal(true);
                                } else {
                                  setChangeNote(true)
                                }
                              }}
                            >
                              {horseNote || ((editEventData[getEDNameFromId(selectedBarn.barnMetadata.horseNoteEventDataId)]
                                && editEventData[getEDNameFromId(selectedBarn.barnMetadata.horseNoteEventDataId)].value))
                                ? 'Modify'
                                : 'Add'} Horse Note
                            </Link>
                          )
                        }
                      </Box>

                    )
                }
              </ListItemText>
            )
            : (
              <ListItemText primaryTypographyProps={{ fontWeight: 300 }}>No Horse Note</ListItemText>
            )
        }

      </ListItem>

      <AddEditBillableModal
        open={openAddEditHorseBillableModal}
        billable={horseBillable || null}
        onClose={(didAddOrUpdate) => {
          setOpenAddEditHorseBillableModal(false);
          if (didAddOrUpdate) {
            dispatch(getBillableForTask(barnHorse.horse.id, selectedEvent.id));
          }
        }}
        navigate={() => { }}
        task={selectedEvent}
        horses={[barnHorse]}
        barnHorse={barnHorse}
        horseId={(barnHorse && barnHorse.id && barnHorse.horse.id) || null}
        billableDate={selectedEvent.completeDate || selectedEvent.startDate}
        billableDescription={selectedEvent.name}
        billableTaskTypeId={selectedEvent.eventTemplateId}
        disableHorseTaskLookup
      />
      <AddEditModal
        open={openAddEditHorseNoteModal}
        horseNote={horseNote || null}
        presetType={null}
        horseId={barnHorse.horse.id}
        pinnedHorseNoteId={(barnHorse && barnHorse.horse.activeNote)
          ? barnHorse.horse.activeNote.id
          : null}
        onClose={() => {
          setOpenAddEditHorseNoteModal(false);
          dispatch(getNoteForTask(barnHorse.horse.id, selectedEvent.id))
        }}
        taskId={selectedEvent.id}
      />
    </Box>
  );
}

EditTaskEventDataComponent.propTypes = {
  onChange: PropTypes.func,
  taskEventData: PropTypes.object,
  completeDate: PropTypes.any,
  selectedEvent: PropTypes.object,
  barnHorse: PropTypes.object,
  showDivider: PropTypes.bool,
};

EditTaskEventDataComponent.defaultProps = {
  onChange: null,
  taskEventData: null,
  completeDate: new Date(),
  selectedEvent: {},
  barnHorse: {},
  showDivider: true,
};

export default EditTaskEventDataComponent;
